import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import ToggleBtn3Op from '../inputs/ToggleBtn3Op/ToggleBtn3Op';

import './navbar.css'

const Navbar = () => {

  const [showMenu, setShowMenu] = useState(false);
  const [theme, setTheme] = useState(localStorage.getItem('theme'));

  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
}, [theme]);


  return (
    <>
      <nav className='nav'>
        <div className='wrapper'>

          <div className='menulogo'>
            <button className="material-icons-outlined" onClick={() => setShowMenu(!showMenu)}>menu</button>
          </div>

          <div className='logo lateral'>
            <img src={require('../../assets/logoPoptelera.png')} alt="Logo Poptelera" />
          </div>

          <ul className={showMenu ? 'menu show' : 'menu'}>

            <NavLink to={'/'} onClick={() => setShowMenu(!showMenu)}>
              Home
            </NavLink>
            <NavLink to={'/artists'} onClick={() => setShowMenu(!showMenu)}>
              Artistas
            </NavLink>
            <NavLink to={'/songs'} onClick={() => setShowMenu(!showMenu)}>
              Canciones
            </NavLink>
            <NavLink to={'/villages'} onClick={() => setShowMenu(!showMenu)}>
              Pueblos
            </NavLink>
            <NavLink to={'/votes'} onClick={() => setShowMenu(!showMenu)}>
              Votaciones
            </NavLink>
            <NavLink to={'/users'} onClick={() => setShowMenu(!showMenu)}>
              Usuarios
            </NavLink>

          </ul>

          <div className='logo central'>
            <img src={require('../../assets/poptelera-linea.png')} alt="Logo Poptelera" />
          </div>



          <div className='userlogo'>
            <ToggleBtn3Op theme={setTheme}/>
          </div>
        </div>
      </nav>



    </>
  )
}
export default Navbar